<app-standard-page-layout class="w-full">
    
    <app-whats-on></app-whats-on>
    
</app-standard-page-layout>
